__turbopack_context__.v({
  "closeIconBar": "transcript-module-scss-module__dJapYq__closeIconBar",
  "transcriptHeader": "transcript-module-scss-module__dJapYq__transcriptHeader",
  "transcriptText": "transcript-module-scss-module__dJapYq__transcriptText",
});
